var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJammer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.3,19.5c-0.4-0.4-0.9-0.6-1.4-0.6l0,0c-0.6,0-1,0.2-1.4,0.6l-0.6-0.7c0.5-0.5,1.3-0.9,2.1-0.9l0,0 c0.8,0,1.5,0.3,2.1,0.9L13.3,19.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.1,20.7c-0.1-0.2-0.4-0.2-0.5,0L10.9,20c0.5-0.5,1.3-0.5,1.8,0L12.1,20.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.6,18.2c-1.5-1.5-4-1.5-5.5,0l-0.6-0.6c1.9-1.9,4.9-1.9,6.8,0L14.6,18.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16,16.8c-2.3-2.2-5.9-2.2-8.2,0l-0.6-0.6c2.6-2.6,6.9-2.6,9.5,0L16,16.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.1,22.8H9.6c-2.2,0-5.9,0-5.9-3.8v-8c0-0.7,0.6-1.3,1.3-1.3h3.8c0.7,0,1.3,0.6,1.3,1.3v0.3 c0,0.4,0.3,0.7,0.7,0.7h2c0.4,0,0.7-0.3,0.7-0.7V11c0-0.7,0.6-1.3,1.3-1.3h3.8c0.7,0,1.3,0.6,1.3,1.3v8.1 C20,22.8,16.3,22.8,14.1,22.8z M5,10.5c-0.2,0-0.4,0.2-0.4,0.4V19c0,2.4,1.8,2.9,5,2.9h4.6c3.2,0,5-0.5,5-2.9v-8 c0-0.3-0.2-0.4-0.4-0.4H15c-0.2,0-0.4,0.2-0.4,0.4v0.3c0,0.9-0.7,1.6-1.6,1.6h-2c-0.9,0-1.6-0.7-1.6-1.6V11 c0-0.3-0.2-0.4-0.4-0.4H5V10.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.1,10.5H15c-0.2,0-0.4-0.2-0.4-0.5V5.3c0,0,0-0.1-0.1-0.1H9.2c0,0-0.1,0-0.1,0.1v4.8 c0,0.2-0.2,0.5-0.5,0.5h-3c-0.2,0-0.4-0.2-0.4-0.5V5.3C5.1,3,7,1.2,9.2,1.2h5.2c2.3,0,4.1,1.8,4.1,4.1v4.8 C18.6,10.3,18.4,10.5,18.1,10.5z M15.4,9.6h2.3V5.3c0-1.8-1.5-3.3-3.2-3.3H9.2C7.5,2.1,6,3.5,6,5.3v4.3h2.3V5.3 c0-0.5,0.4-1,1-1h5.2c0.5,0,1,0.4,1,1v4.3H15.4z"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJammer);
export default __webpack_public_path__ + "static/media/jammer.ac4bf016348e5c0eaab7251935815f06.svg";
export { ForwardRef as ReactComponent };